// this is aliased in webpack config based on server/client build
import Axios from "axios"
import {SET_API_ERROR, SET_API_STATUS} from "../types"

const logRequests = false

let apiTimeout = 10000

export const api = {
    handler: Axios.create({
        baseURL: '/api',
        timeout: apiTimeout,
        responseType: 'json'
    }),
    context: 'client'
}

export function request(commit, route, data = null, method = 'get') {
    // access the requested HTTP method to be executed
    let execute = methods[method.toLowerCase()]

    // reject for an invalid method
    if (typeof execute !== 'function') {
        return new Promise((resolve, reject) => {
            logRequests && console.log('Invalid HTTP method');
            return reject()
        });
    }

    // enables or disables response caching (default: enabled)
    // for the 'GET' method only, responses are cached on the originating machine (server or browser)
    // to disable caching for a GET request, pass a false boolean as the 'data' argument
    if (method === 'get' && data === null) data = true

    logRequests && console.log('api ' + method.toUpperCase() + ' to ' + route + ((method === 'get' && data) ? ' (cache requested)' : ''))

    return new Promise((resolve, reject) => {
        // set the API_BUSY flag to true, indicating a request is in progress
        commit(SET_API_STATUS, 'busy')

        // start a timeout to disable the busy flag for requests that take longer than the specified timeout
        let timeout = setTimeout(function () {
            console.log('API timed out')
            commit(SET_API_STATUS, 'idle')
        }, apiTimeout)

        // finally execute the method
        // on success clear the API_ERROR and API_BUSY flag
        // on failure clear only the API_BUSY flag.
        // for both clear the API timeout.
        return execute(route, data)
            .then(responseData => {
                clearTimeout(timeout)
                commit(SET_API_STATUS, 'idle')
                commit(SET_API_ERROR, false)
                resolve(responseData)
            })
            .catch(error => {
                clearTimeout(timeout)
                commit(SET_API_STATUS, 'idle')
                commit(SET_API_ERROR, {
                    code: (error.response) ? error.response.status : 'whammo',
                    message: error.message,
                })
                reject(error)
            })
    })
}

export const methods = {
    get (url, useCache = true) {
        const cache = api.cachedData
        if (useCache && cache && cache.has(url)) {
            logRequests && console.log('api cache response')
            return Promise.resolve(cache.get(url))
        }

        return new Promise((resolve, reject) => {
            api.handler.get(url)
                .then(response => {
                    const val = response.data
                    // mark the timestamp when this item is cached
                    if (typeof val === 'object') val.__lastUpdated = Date.now()
                    cache && cache.set(url, val)
                    resolve(val)
                })
                .catch(errors => {
                    reject(errors)
                })
        })
    },
    post (url, data) {
        return new Promise((resolve, reject) => {
            api.handler.post(url, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(errors => {
                    reject(errors)
                })
        })
    }
}

export default request;


// WEBPACK FOOTER //
// ./src/store/api/index.js